/** Keep emails, phone numbers, and Latin text readable inside RTL layouts. */
export const ltrIsolateSx = {
  direction: "ltr",
  unicodeBidi: "isolate",
} as const;

/** Inline LTR block for mixed copyright / contact lines on RTL pages. */
export const ltrEmbedSx = {
  direction: "ltr",
  unicodeBidi: "embed",
  display: "inline-block",
} as const;

/** Apply html+body language and direction so RTL/LTR switch without a refresh. */
export function applyDocumentDirection(language: string | undefined): void {
  const isRTL = String(language ?? "").toLowerCase().startsWith("ar");
  const dir = isRTL ? "rtl" : "ltr";
  const lang = isRTL ? "ar" : "en";
  const html = document.documentElement;
  html.setAttribute("dir", dir);
  html.setAttribute("lang", lang);
  document.body.setAttribute("dir", dir);
  document.body.lang = lang;
}
